import { ResourceType } from "@/services/cloudchipr.api";

export const resourceTypesMappingForAttachments = new Map<
  ResourceType,
  ResourceType[]
>([
  ["ebs", ["ec2", "eks", "asg"]],
  ["ec2", ["ebs"]],
]);
